import { render, staticRenderFns } from "./DeliveryGeneralChecksCard.vue?vue&type=template&id=4daabcd2"
import script from "./DeliveryGeneralChecksCard.vue?vue&type=script&lang=ts"
export * from "./DeliveryGeneralChecksCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports